export interface CatalogDelayCode {
  DelayCodeId: number | null;
  DelayCodeName: string;
  DelayCategoryId: number | null;
  DelayCategoryName: string | null;
  DelayCategoryColor: string | null;
  ParentDelayCodeId: number | null;
  DelayAreaAssetId: string | number | null;
  IsAtTop: boolean;
  IsAtBottom: boolean;
  IsBranch: boolean;
  IsLeaf: boolean;
  SortOrder: number | null;
  IsActive: boolean | null;
}

export const CATALOG_DELAY_INITIAL_VALUES: CatalogDelayCode = {
  DelayCodeId: null,
  DelayCodeName: "",
  DelayCategoryId: null,
  DelayCategoryName: null,
  DelayCategoryColor: null,
  ParentDelayCodeId: null,
  DelayAreaAssetId: null,
  IsAtTop: false,
  IsAtBottom: false,
  IsBranch: false,
  IsLeaf: false,
  SortOrder: null,
  IsActive: true,
};
